<template>
   <div id="app">
    <transition name="fade">
      <router-view/>
    </transition>
   </div>
</template>

<script>  
  import $ from 'jquery'
  export default {
    name: 'app',
    data () {
        return {
          
        }
      },
    components: {
       
    },
    created() {
        //delete this.$route.query.referral_links;

        console.log(this.$route.query)

        if (this.$route.query.franchiseLead) {
             this.$cookies.set("franchiseLead",this.$route.query.franchiseLead,"4m", null, ".finvasia.com");
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue